import React from 'react';
import { ReactComponent as ChevronLeft } from 'products/nomad_insurance/assets/img/icons/chevron-left.svg';
import ProgressBar from '../ProgressBar';
import {
  StyledStepContainer,
  Controls,
  BackButton,
  BackIcon,
  StepDisplay,
  Content
} from './styled';

const StepContainer = ({
  children,
  stepNumber,
  totalSteps,
  onStepChange
}: {
  children: React.ReactNode;
  stepNumber: number;
  totalSteps: number;
  onStepChange: Function;
}) => {
  return (
    <StyledStepContainer>
      <Controls>
        <BackButton onClick={() => onStepChange(-1)}>
          <BackIcon>
            <ChevronLeft />
          </BackIcon>
          Back
        </BackButton>
        <ProgressBar totalSteps={totalSteps} stepNumber={stepNumber} />
        <StepDisplay>
          Step {stepNumber} of {totalSteps}
        </StepDisplay>
      </Controls>
      <Content>{children}</Content>
    </StyledStepContainer>
  );
};

export default StepContainer;
